import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  standalone: false,
})
export class AlertModalComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() modalClass: string = '';
  @Input() btnText: string = '';
  @Input() btnConfirmText: string = '';
  @Output() close = new EventEmitter();

  closeModal() {
    this.close.emit();
  }

  constructor(public activeModal: NgbActiveModal) {}

  confirm() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.close(false);
  }
}
